import { render, staticRenderFns } from "./companyRechargeTotal.vue?vue&type=template&id=20a0062a&scoped=true&"
import script from "./companyRechargeTotal.vue?vue&type=script&lang=js&"
export * from "./companyRechargeTotal.vue?vue&type=script&lang=js&"
import style0 from "./companyRechargeTotal.vue?vue&type=style&index=0&id=20a0062a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0062a",
  null
  
)

export default component.exports